import { useState, useEffect, useCallback } from 'react';
import { fetchApi } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

export function useInvites() {
  const { user, role } = useAuth();
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);

  const load = useCallback(async () => {
    if (!user || (role !== 'company' && role !== 'admin')) {
      setLoading(false);
      return;
    }
    try {
      const data = await fetchApi('/api/invites');
      setInvites(data.invites || []);
    } catch (err) {
      console.error('Failed to load invites:', err);
    } finally {
      setLoading(false);
    }
  }, [user, role]);

  useEffect(() => { load(); }, [load]);

  const createInvite = useCallback(async (invitedEmail, personalMessage) => {
    setCreating(true);
    try {
      const data = await fetchApi('/api/invites', {
        method: 'POST',
        body: JSON.stringify({
          invited_email: invitedEmail || null,
          personal_message: personalMessage || null,
        }),
      });
      await load();
      return data.invite;
    } catch (err) {
      console.error('Failed to create invite:', err);
      throw err;
    } finally {
      setCreating(false);
    }
  }, [load]);

  const activeInvites = invites.filter(i => !i.used_at && new Date(i.expires_at) > new Date());
  const usedInvites = invites.filter(i => i.used_at);
  const expiredInvites = invites.filter(i => !i.used_at && new Date(i.expires_at) <= new Date());

  return { invites, activeInvites, usedInvites, expiredInvites, loading, creating, createInvite, refresh: load };
}
